import { render } from "./ContactSection.vue?vue&type=template&id=62bfc7a4&scoped=true"
import script from "./ContactSection.vue?vue&type=script&lang=js"
export * from "./ContactSection.vue?vue&type=script&lang=js"

import "@/styles/Contact-Section.css?vue&type=style&index=0&id=62bfc7a4&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62bfc7a4"]])

export default __exports__